var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: {
          loading: _vm.loading,
          search: _vm.search,
          items: _vm.items,
          headers: _vm.headers
        },
        scopedSlots: _vm._u([
          {
            key: "item.softurl",
            fn: function fn(_ref) {
              var item = _ref.item
              return [
                _c(
                  "a",
                  {
                    attrs: {
                      href: item.softurl,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }
                  },
                  [_vm._v(_vm._s(item.softurl))]
                )
              ]
            }
          },
          {
            key: "item.outdated",
            fn: function fn(_ref2) {
              var item = _ref2.item
              return [
                _c(
                  "span",
                  {
                    class: {
                      "warning--text": item.outdated
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(item.outdated ? "Outdated" : "Up to date") +
                        " "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "item.script_name",
            fn: function fn(_ref3) {
              var item = _ref3.item
              return [
                _c(
                  "span",
                  {
                    staticClass: "app-installer-inline"
                  },
                  [
                    _c("v-img", {
                      staticClass: "mr-2 app-installer-logo",
                      attrs: {
                        src: "/static/img/app-installer-icons/".concat(
                          item.logo
                        ),
                        contain: "",
                        width: "26",
                        height: "26"
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "app-installer-name"
                      },
                      [_vm._v(_vm._s(item.script_name))]
                    )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "item.actions",
            fn: function fn(_ref4) {
              var item = _ref4.item
              return [
                _c(
                  "gg-btn",
                  {
                    staticClass: "mr-2",
                    attrs: {
                      secondary: "",
                      disabled: !item.adminurl && !item.isWp,
                      loading: _vm.loadingLogin === item.insid
                    },
                    on: {
                      click: function click($event) {
                        return _vm.handleLogin(item)
                      }
                    }
                  },
                  [
                    _vm._v(" Dashboard "),
                    _c(
                      "v-icon",
                      {
                        staticClass: "ml-1",
                        attrs: {
                          small: ""
                        }
                      },
                      [_vm._v("mdi-open-in-new")]
                    )
                  ],
                  1
                ),
                _c(
                  "gg-btn",
                  {
                    on: {
                      click: function click($event) {
                        return _vm.openModal("delete", item)
                      }
                    }
                  },
                  [_vm._v("Delete")]
                )
              ]
            }
          }
        ])
      }),
      _c("delete-modal", {
        attrs: {
          opened: _vm.modals.delete,
          installation: _vm.selectedInstallation,
          "app-name": "Application"
        },
        on: {
          close: function close($event) {
            return _vm.closeModal("delete")
          },
          deleted: _vm.handleFetchApps
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }